export const scrollToSection = (hash) => (e) => {
  if (e) e.preventDefault();
  const target = document.querySelector(hash);
  if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
};
